export function debounce<T, K>(
  func: (...args: T[]) => K,
  wait = 100,
  immediate = false,
) {
  let timeoutId: NodeJS.Timeout | undefined;
  let timestamp: number;
  let result: K;

  function later(...args: T[]) {
    const last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeoutId = setTimeout(() => later(...args), wait - last);
    } else {
      timeoutId = undefined;

      if (!immediate) {
        result = func(...args);
      }
    }
  }

  return (...args: T[]) => {
    timestamp = Date.now();

    const callNow = immediate && !timeoutId;

    timeoutId ??= setTimeout(() => later(...args), wait);

    if (callNow) {
      result = func(...args);
    }

    return result;
  };
}
